import React, { ReactElement } from 'react';
import { Box, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { DisplayGroupProps } from '@bcp-nextgen-dx-touchpoint-framework/react-core';
import { ComponentInfo, DisplayGroupRender } from '@components';
import { usePageContainerHelper } from './pageContainer.helper';

export const PageContainer: React.FC<DisplayGroupProps> = (props: DisplayGroupProps): ReactElement => {
	usePageContainerHelper();
	const { palette } = useTheme();

	return (
		<ComponentInfo name="PageContainer">
			<Box
				styles={{
					position: 'relative',
					minWidth: '100vw',
					minHeight: '100vh',
					display: 'flex',
					flexDirection: 'column',
					background: palette.background.b2,
				}}
			>
				<DisplayGroupRender displayGroupsProps={props} />
			</Box>
		</ComponentInfo>
	);
};
